/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button } from '@mui/material';
import * as React from 'react';
import { loadFromLocalStorage } from '../common/localStorage';

interface Props {
    selected: any
}
class Open extends React.Component<Props, { isRunningFromDesktop: boolean }>{
    state = {
        isRunningFromDesktop: false
    };
    componentDidMount() {
        const clientMode: any = loadFromLocalStorage('Client Mode');
        if (clientMode != null && clientMode !== undefined && clientMode === 'Desktop') {
            this.setState({ isRunningFromDesktop: true });
        }
    }
    handleClickOpen = (event: any) => {
        if (this.props.selected !== undefined && this.props.selected.length === 1) {
            const openServiceCaseEvent: any = new CustomEvent(
                'openservicecase',
                {
                    detail: {
                        servicecaseid: this.props.selected[0]
                    },
                    bubbles: true,
                    cancelable: true
                }
            );
            event.currentTarget.dispatchEvent(openServiceCaseEvent);
        }
    };
    render() {
        const { isRunningFromDesktop } = this.state;
        return (
            isRunningFromDesktop &&
            <Button
                variant="outlined"
                id="openbutton"
                style={
                    {
                        backgroundColor: '#ffffff',
                        marginRight: '5px'
                    } as React.CSSProperties
                }
                disabled={this.props.selected.length !== 1}
                onClick={this.handleClickOpen}
            >
                Open
            </Button>
        );

    }
}
export default (Open);
